import React from 'react';

import { cx } from '@emotion/css';

import styles from './whoWeAre.module.scss';

export const WhoWeAreView = () => {
  return (
    <section className={styles.about_us}>
      <div className={styles.root}>
        <div className={styles.about_us_card_block}>
          <div className={styles.container}>
            <div className={cx(styles.inner_section, styles.root)}>
              <div className={styles.heading_wrapers}>
                <h1 className={cx(styles.site_title, styles.h1)}>
                  Connect with Our Team
                </h1>
                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  We make property care easy. From electrical work to plumbing,
                  heating, and appliance repairs, we handle all your maintenance
                  needs under one roof.
                </p>

                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  Our story started with our founders, James & Jack. They
                  dedicated in property management before starting Qeeper. They
                  understood what property owners really needed - reliable
                  service providers who actually showed up and got the job done
                  right.
                </p>

                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  Together with Sushil, they built Qeeper to make property care
                  what it should be: simple and hassle-free. Today, we serve
                  homeowners, landlords, letting agents, managers across London,
                  Edinburgh and Brighton.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
